import { SketchLoader } from "@/components/login/SketchLoader";
import { classNames } from "@/utils/classnames";
import React, { ReactNode } from "react";

export interface LoginBrandingProps {
  title: ReactNode;
  subtitle: ReactNode;
  content?: ReactNode;
}

export const LoginBranding: React.FC<LoginBrandingProps> = ({ title, subtitle, content }) => {
  return (
    <div
      className={classNames(
        "w-full lg:basis-1/2",
        "bg-marketing-darkgreen-bg",
        "flex flex-col items-start relative lg:items-center",
      )}
    >
      <div
        className={classNames(
          "mt-16 mb-4 w-full max-w-[500px] px-4",
          "sm:mt-20 sm:mb-12",
          "sm:px-6 sm:pt-6",
          "md:px-8",
          "lg:mb-0",
          "lg:self-end",
          "lg:mt-[calc(15vh+80px)] bg-marketing-darkgreen-bg z-[1]",
          "lg:px-10",
          "lg:mr-[min(8vw,128px)]",
        )}
      >
        <h1 className="text-2xl lg:text-3xl xl:text-4xl font-everett font-medium l:font-regular text-secondary-lime-500">
          {title}
        </h1>
        <h2
          className={classNames(
            "pt-2 pb-2 lg:pb-8 text-marketing-darkgreen-navText font-everettlight",
            "lg:text-xl xl:text-2xl lg:font-normal leading-tight",
          )}
        >
          {subtitle}
        </h2>
        {content}
      </div>

      <div
        className={classNames(
          "absolute bottom-0 left-0 z-[0]",
          "w-full h-full",
          "hidden lg:block lg:h-[320px]",
        )}
      >
        <SketchLoader id={"login"} className={"h-full w-full"} />
      </div>
    </div>
  );
};
